<template>
  <div
    class="relative z-0 mb-2 w-full group"
    :class="statusClass"
    :required="required">
     <label :for="id" class="text-sm mb-2 block">
      {{ label }}
      <sup v-if="required" aria-hidden="true">*</sup>
      <span v-if="required" class="sr-only">(Pflichtfeld)</span>
    </label>
    <input
      ref="inputRef"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      :id="id"
      :required="required"
      :aria-required="required"
      class="w-full p-3 border rounded-md mb-2 invalid:border-red-500 invalid:!bg-red-50 focus:border-tertiary/50 focus:outline-0 peer invalid:text-red-500 focus:invalid:border-red-500 transition-all group-[.invalid]:bg-red-50 group-[.invalid]:text-red-500 group-[.invalid]:border-red-500"
      :class="
        isEmpty && required
          ? '!border-red-500 bg-red-50 text-red-500 invalid:text-red-500 invalid:!bg-red-50 invalid:border-red-500'
          : 'border-secondary/50 text-tertiary '
      "
      @change="validate" />
    <div class="absolute -bottom-4 text-primary text-sm">{{ meldung }}</div>
  </div>
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";
/** Komponente zur Darstellung eines Betragsfeldes mit Eingabemöglichkeit
 * @displayName Feld Currency Input
 */
export default {
  name: "CurrencyInput",
  data() {
    return {
      meldung: "",
    };
  },
  props: {
    modelValue: Number, // Vue 2: value
    options: Object,
    statusClass: {
      type: String,
      default: "",
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "Betrag",
    },
    id: {
      type: String,
      required: true,
    },
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
  },
  watch: {
    modelValue: {
      handler(newData, oldData) {
        this.validate();
      },
    },
  },
  computed: {
    isEmpty: function () {
      return this.modelValue == "" || this.modelValue == "0";
    },
  },
  methods: {
    validate() {
      let err = false;
      if (this.modelValue == "" || this.modelValue == "0") {
        this.meldung = "Bitte geben Sie einen gültigen Betrag an.";
        err = "true";
      } else {
        this.meldung = "";
        err = "false";
      }
      this.$emit("valChecked", err);
    },
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options);

    return { inputRef };
  },
};
</script>
